import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../../colorVars';
import { NumericalInput } from '../../../../../../../atomic/atomicComponentLibrary/numericalInput/NumericalInput';
import { Body3, Body4, fontSizes } from '../../../../../../../atomic/text/Text';
import style from '../SimpleTacticStyle.module.css';
type Props = {};

export const SimplePositionPriceTrail = observer((props: Props) => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const defaultFn = () => {};
  const isEnabled = tradePlanForm.exitTactics.POSITION_PRICE_TRAIL ?? false;
  const amount = tradePlanForm.exitTactics.POSITION_PRICE_TRAIL?.amount ?? 0;
  const setAmount =
    tradePlanForm.exitTactics.POSITION_PRICE_TRAIL?.setAmount ?? defaultFn;

  return (
    <div className={style.container}>
      <div className={style.labelAndCheckbox}>
        <input
          style={{ margin: '0 5px 0 0' }}
          type="checkbox"
          checked={isEnabled}
          onChange={() => {
            if (isEnabled) {
              tradePlanForm.removeExitTactic('POSITION_PRICE_TRAIL');
            } else {
              tradePlanForm.addExitTactic('POSITION_PRICE_TRAIL');
            }
          }}
        />
        <Body3 fontWeight={700} color={colors.lightGrey}>
          Position Price Trail
        </Body3>
      </div>
      <div className={style.controls}>
        <div className={style.labelAndControl}>
          <Body4 color={colors.lightGrey}>Amount</Body4>
          <NumericalInput
            disabled={!isEnabled}
            width="50px"
            maxHeight="23px"
            icon="$"
            fontSize={fontSizes.body4}
            fontColor="white"
            backgroundColor="grey"
            controlledValue={amount}
            onChange={setAmount}
          />
        </div>
      </div>
    </div>
  );
});
